import { COLORS } from "components";

export interface ChartTooltipProps {
  x: string;
  points: Highcharts.TooltipFormatterContextObject[];
  unitYAxis: string;
  showClickMessage?: boolean;
}

export const createSiteTooltip = (props: ChartTooltipProps): string => {
  const { x, points, unitYAxis } = props;

  return `
    <div style="font-size: 12px; padding: 5px; display: flex; flex-direction: column; gap: 5px;">
      <strong style="color: ${COLORS.Mainblue}">${x}</strong>
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
        Total:
        <span style="font-weight: bold;">${Number((points?.[0] as any)?.total?.toFixed(2)).toLocaleString('en-US')} ${unitYAxis}</span>
      </div>
      <div style="display: flex; align-items: center; margin-top: 10px; color: ${COLORS.Mainblue}">
        <strong> Click to see more details </strong>
      </div>
    </div>
  `;
};

export const createTooltipConfig = (unitYAxis: string) => ({
  shared: true,
  borderRadius: 8,
  shadow: false,
  padding: 24,
  useHTML: true,
  outside: true,
  positioner(labelWidth: any, labelHeight: any, point: any) {
    return {
      x: point.plotX,
      y: point.plotY - labelHeight,
    };
  },
  formatter(this: Highcharts.TooltipFormatterContextObject) {
    const props: ChartTooltipProps = {
      x: String(this!.x),
      points: this!.points || [],
      unitYAxis,
      showClickMessage: true,
    };

    return createSiteTooltip(props);
  },
})




